/**
 * Rubina Irfan — ri-collections-page.js
 * Filter tabs functionality for collections page
 */

(function () {
  'use strict';

  const grid = document.getElementById('ri-collections-grid');
  if (!grid) return;

  const filterContainer = document.querySelector('.ri-collections__filters');
  if (!filterContainer) return;

  /**
   * Show/hide cards based on filter value
   * @param {string} filter - 'all' or tag value
   */
  function applyFilter(filter) {
    const cards = grid.querySelectorAll('.ri-col-card');

    cards.forEach(function (card) {
      // Remove animation class first
      card.classList.remove('ri-animate-in');

      if (filter === 'all') {
        // Show all cards
        card.removeAttribute('data-hidden');
        // Trigger reflow for animation
        void card.offsetWidth;
        card.classList.add('ri-animate-in');
      } else {
        // Check if card has matching tag
        const tags = card.dataset.tags || '';
        const tagList = tags.split(',').map(function (t) { return t.trim(); });

        if (tagList.includes(filter)) {
          card.removeAttribute('data-hidden');
          // Trigger reflow for animation
          void card.offsetWidth;
          card.classList.add('ri-animate-in');
        } else {
          card.setAttribute('data-hidden', '');
        }
      }
    });

    // Clean up animation classes after they run
    setTimeout(function () {
      cards.forEach(function (card) {
        card.classList.remove('ri-animate-in');
      });
    }, 400);
  }

  /**
   * Update active tab state
   * @param {HTMLElement} activeTab - The clicked tab
   */
  function setActiveTab(activeTab) {
    const tabs = filterContainer.querySelectorAll('.ri-filter-tab');

    tabs.forEach(function (tab) {
      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');
    });

    activeTab.classList.add('is-active');
    activeTab.setAttribute('aria-selected', 'true');
  }

  // Event delegation for filter tabs
  filterContainer.addEventListener('click', function (event) {
    const tab = event.target.closest('.ri-filter-tab');
    if (!tab) return;

    // Don't reapply if already active
    if (tab.classList.contains('is-active')) return;

    const filter = tab.dataset.filter;
    if (!filter) return;

    setActiveTab(tab);
    applyFilter(filter);
  });

  // Keyboard navigation for tabs
  filterContainer.addEventListener('keydown', function (event) {
    const tabs = Array.from(filterContainer.querySelectorAll('.ri-filter-tab'));
    const currentIndex = tabs.findIndex(function (tab) {
      return tab.classList.contains('is-active');
    });

    let newIndex = currentIndex;

    switch (event.key) {
      case 'ArrowLeft':
        newIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
        event.preventDefault();
        break;
      case 'ArrowRight':
        newIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
        event.preventDefault();
        break;
      case 'Home':
        newIndex = 0;
        event.preventDefault();
        break;
      case 'End':
        newIndex = tabs.length - 1;
        event.preventDefault();
        break;
    }

    if (newIndex !== currentIndex) {
      tabs[newIndex].focus();
      tabs[newIndex].click();
    }
  });
})();
